import React from 'react';
import PropTypes from 'prop-types';

const ThumbsUpIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Thumbs up"
  >
    <path d="M9.5 21H6C4.895 21 4 20.105 4 19V11C4 9.895 4.895 9 6 9H9.5V21Z" stroke="currentColor" strokeWidth="1.8" />
    <path d="M9.5 10L13 3C13.828 3 14.5 3.672 14.5 4.5V8.5H18.5C19.88 8.5 20.831 9.882 20.338 11.17L18.04 17.17C17.744 17.944 17.001 18.455 16.173 18.455H9.5V10Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
  </svg>
);

ThumbsUpIcon.propTypes = {
  className: PropTypes.string
};

ThumbsUpIcon.defaultProps = {
  className: ''
};

export default ThumbsUpIcon;
